var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VideoPlayer',{staticClass:"fragment-media--video-player",attrs:{"type":_vm.type,"data":_vm.content,"ads":_vm.ads}})
}
var staticRenderFns = []

export { render, staticRenderFns }